import { AlertTriangle, ChevronDown, RotateCcw } from 'lucide-react';
import { Button } from '../../design-system/Button';
import type { StructuredError } from '../../engine/core/types';

interface ErrorPanelProps {
  error: StructuredError;
  onReset: () => void;
}

export function ErrorPanel({ error, onReset }: ErrorPanelProps): React.JSX.Element {
  return (
    <section className="error-panel" role="alert">
      <div className="error-panel__icon"><AlertTriangle /></div>
      <p className="mono label">{error.code}</p>
      <h1>{error.title}</h1>
      <p>{error.message}</p>
      <div className="recommendation"><strong>Recommended</strong><span>{error.recommendation}</span></div>
      <details>
        <summary><ChevronDown />Technical details</summary>
        <pre>{error.technical}</pre>
      </details>
      <Button variant="primary" onClick={onReset}><RotateCcw />Choose another file</Button>
    </section>
  );
}
